import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import VueAMap from 'vue-amap';
import 'babel-polyfill'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import './styles/index.scss' // global css
import '@/icons' // icon
import Rsa from "@/utils/rsa"
import { isAuth } from '@/utils'
//import './permission' // permission control
import i18n from './lang' // Internationalization
import loadingUtil from '@/components/Loading/index.js'
import moment from 'moment'; //导入模块
import _ from 'lodash'
moment.locale('zh-cn'); //设置语言 或 moment.lang('zh-cn'); 
Vue.prototype.$moment = moment;//赋值使用

Vue.use(loadingUtil)
Vue.prototype.Rsa = Rsa 
Vue.prototype.isAuth = isAuth     // 权限方法
Vue.prototype._ = _

//配置高德地图
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  // 高德key
  key: '9c7fdb24b3438f18914f14e12e9a1d2d',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.MarkerClusterer', 'AMap.Geolocation', 'AMap.Geocoder'],
  v: '1.4.4'
})
//重置表单，formRef为表单的ref值，excludeFields为要排除重新初始化值得属性
Vue.prototype.$reset = function (formRef, ...excludeFields) {
  this.$refs[formRef].resetFields();
  let obj1 = this.$data;
  let obj2 = this.$options.data.call(this);
  if (!excludeFields || excludeFields.length === 0) {
    excludeFields = ["rules"];
  }
  for (let attrName in obj1) {
    if (excludeFields && excludeFields.includes(attrName)) {
      continue;
    }
    obj1[attrName] = obj2[attrName];
  }
};
Vue.config.productionTip = false
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js